import { css } from '@emotion/react';

import { OtherIconsSet } from 'src/utils/constants/IconsConstants';

import { colors } from '../../../styles/colors';
import { ZeeFontBold, getOtherIcons } from '../../../styles/font';
import { MediaBP as MQ } from '../../../styles/mediaQuery';
import { flex } from '../../../styles/utils';

export const appStoresContainer = css`
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontBold(14)};
  ${flex()};
  gap: 14px;
`;

export const socialMediaContainer = css`
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontBold(14)};
  ${flex()};
  gap: 12px;
`;

export const socialMediaIconContainer = css`
  width: 42px;
  height: 42px;
  ${flex()};
  background-color: ${colors.PrimaryWhiteColorAlpha08};
  border: 1px solid ${colors.PrimaryWhiteColorAlpha05};
  border-radius: 21px;
`;
export const iconsText = css`
  display: none;
  color: ${colors.GrayD8};
  ${MQ.MediaMd} {
    display: inherit;
  }
`;
export const iconsContainer = css`
  ${flex('column', 'center', 'center')};
  padding: 20px 0px 20px 0px;
  gap: 40px;
  ${MQ.MediaMd} {
    ${flex('row', 'space-between', 'center')};
    padding: 0px 64px;
  }
  ${MQ.MediaLg} {
    padding: 0px;
  }
`;

export const facebook = css`
  font-size: 21px;
  font-weight: 400;
  padding-top: 3px;
  ${getOtherIcons(OtherIconsSet.FACEBOOK)};
`;
export const instagram = css`
  font-size: 21px;
  font-weight: 400;
  ${getOtherIcons(OtherIconsSet.INSTAGRAM)};
`;
export const twitter = css`
  font-size: 21px;
  font-weight: 400;
  ${getOtherIcons(OtherIconsSet.TWITTER)};
`;
export const youtube = css`
  font-size: 21px;
  font-weight: 400;
  ${getOtherIcons(OtherIconsSet.YOUTUBE)};
`;
